export function CardItemIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33337 4.6665C1.33337 3.56193 2.2288 2.6665 3.33337 2.6665H12.6667C13.7713 2.6665 14.6667 3.56193 14.6667 4.6665V11.3332C14.6667 12.4377 13.7713 13.3332 12.6667 13.3332H3.33337C2.2288 13.3332 1.33337 12.4377 1.33337 11.3332V4.6665ZM3.33337 3.99984C2.96518 3.99984 2.66671 4.29831 2.66671 4.6665V11.3332C2.66671 11.7014 2.96518 11.9998 3.33337 11.9998H12.6667C13.0349 11.9998 13.3334 11.7014 13.3334 11.3332V4.6665C13.3334 4.29831 13.0349 3.99984 12.6667 3.99984H3.33337Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66671 10.6665C4.66671 10.2983 4.96518 9.99984 5.33337 9.99984H10.6667C11.0349 9.99984 11.3334 10.2983 11.3334 10.6665C11.3334 11.0347 11.0349 11.3332 10.6667 11.3332H5.33337C4.96518 11.3332 4.66671 11.0347 4.66671 10.6665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66671 5.33317C4.66671 4.96498 4.96518 4.6665 5.33337 4.6665H10.6667C11.0349 4.6665 11.3334 4.96498 11.3334 5.33317V8.6665C11.3334 9.03469 11.0349 9.33317 10.6667 9.33317H5.33337C4.96518 9.33317 4.66671 9.03469 4.66671 8.6665V5.33317ZM6.00004 5.99984V7.99984H10V5.99984H6.00004Z"
        fill="currentColor"
      />
    </svg>
  );
}
